<template>
  <page-outline :title="$t('Webheader.usercompany')">
    <template slot="pageContent">
      <div>
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div class="mt-0">
                <div>
                  <f7-list class="mb-2">
                    <f7-list-item :class="additionalClass">
                      <div class="d-flex">
                        <!-- Left section filtre -->
                        <div>
                          <b-button class="btn btnFilter"
                            @click="displayFilter = !displayFilter">
                            <i v-if="displayFilter" class="fa-light fa-minus"></i>
                            <i v-else class="fa-light fa-plus"></i>
                          </b-button>
                        </div>
                        <div class="mx-3">
                          <b-button class="btn btnFilter"
                            @click="refreshInbox()">
                            <i class="fa-light fa-rotate-right"></i>
                          </b-button>
                        </div>
                        <!-- Right section filtre -->
                        <div>
                          <b-button class="btn btnFilter_2"
                            @click="exportUserCompany()">
                            <i class="fa-light fa-upload"></i>
                            <span class="fab-label">{{ $t('common.extract_list') }}</span>
                          </b-button>
                        </div>
                      </div>
                    </f7-list-item>
                    <!-- Sélection des valeurs de Filtre -->
                    <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}">
                      <b-row class="min-w-100">
                        <!-- Filtre nameCompany -->
                        <b-col sm="6" lg="3" cols="12" class="filter-item mb-3">
                          <span class="filter-item-title">
                            {{ $t('administration.company') }}
                          </span>
                          <span class="filter-item-content">
                            <input v-model="nameCompany"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': nameCompany}"
                              :placeholder="$t('administration.company_name')">
                            </input>
                          </span>
                        </b-col>
                        <!--Filtre login -->
                        <b-col sm="6" lg="3" cols="12" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('administration.login') }}</span>
                          <span class="filter-item-content">
                            <input v-model="login"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': login}"
                              :placeholder="$t('administration.login')">
                            </input>
                          </span>
                        </b-col>
                        <!-- Filtre userActive -->
                        <b-col sm="6" lg="3" cols="8" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('administration.active') }}</span>
                          <span class="filter-item-content">
                            <select ref="selectDoctype"
                              v-model="userActive" class="pt-2 cursor fs-14px-important h-auto z-2">
                              <option value="">{{ $t('administration.select_activity') }}</option>
                              <option value="0"> {{ $t('administration.no') }} </option>
                              <option value="1"> {{ $t('administration.in_prgrss') }} </option>
                              <option value="2"> {{ $t('administration.yes') }} </option>
                            </select>
                            <i class="fa-light fa-chevron-down p-1 cursor float-right mt--22px-important z-1" id="status-chevron">
                            </i>
                          </span>
                        </b-col>
                        <!-- Bouton Effacer et Appliquer -->
                        <div lg="3" cols="12" class="d-flex flex-row-reverse mt-3 pr-0">
                          <b-button class="btn" size="sm"
                            @click="applyFilter()">
                            {{ $t('filter.fltr') }}
                          </b-button>
                          <b-button class="btn mr-3" size="sm"
                            @click="clearFilterFields"
                            :disabled="!hasInputFilter">
                            {{ $t('filter.clr_fltr_field') }}
                          </b-button>
                        </div>
                      </b-row>
                    </f7-list-item>
                  </f7-list>
                  <spinner v-if="activateSpinner"></spinner>
                  <b-table hover v-else-if="UsersList.length > 0"
                  class="table"
                  :fields="fields"
                  :items="UsersList"
                  :selectable="UsersList.length > 0"
                  empty-text="Pas de résultat"
                  @row-selected="seeUserDetails">
                    <template #cell(Active)="data">
                      <i v-if="data.value == 0" class="fa-light fa-xmark btn btn-icon btn-icon-red"></i>
                      <i v-if="data.value == 2" class="fa-light fa-check btn btn-icon btn-icon-green"></i>
                      <i v-if="data.value == 1" class="fa-light fa-warning btn btn-icon btn-icon-orange"></i>
                    </template>
                    <template #cell(delete)="data">
                      <span class="text-center d-inline-block py-4 w-100" @click="activateDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
                      <span>{{ data.value.IdUser }}</span>
                    </template>
                  </b-table>
                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('common.no_result') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'


export default {
  name: 'Users',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_supprimer', true) || this.$engine.rights.rightIs('usercompany_supprimer_admin', true)
    },
    fields () {
      let fields = [
        { key: 'Rights[0].AccountName', label: this.$i18n.t('administration.company'), class: 'text-center', sortable: true },
        { key: 'Login', label: this.$i18n.t('administration.login'), class: 'text-center', sortable: true },
        { key: 'Active', label: this.$i18n.t('administration.active_enable'), class: 'text-center', sortable: true }
      ]

      if (this.canUserDelete) {
        fields.push({ key: 'delete', label: this.$i18n.t('administration.del'), thClass: 'text-center table-condensed-ipad col-1', tdClass: 'p-0' })
      }

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    loginDirection () {
      return ((this.sortField === 'login' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
        this.nameCompany ||
        this.login ||
        this.userActive) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idUserAcc: '',
      login: '',
      mode: 1,
      nameCompany: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      userActive: '',
      UsersList: []
    }
  },
  created () {
    this.$bus.$emit('switch-selected-menu', '/usercompany/')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Utilisateurs',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    let defaultFilter = this.$engine.usercompany.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.usercompany.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      let that = this
      let defaultFilter = this.$engine.usercompany.getDefaultFilter()
      this.filterTypeGet = 'list'
      this.setDefaultFilter(defaultFilter)
      this.$engine.usercompany.cleanFilterCondition()
      this.$engine.usercompany.userActive = this.userActive
      this.$engine.usercompany.nameCompany = this.nameCompany
      this.$engine.usercompany.login = this.login

      for (let propertyCustom in filterConditions) {
        this.$engine.usercompany[propertyCustom] = filterConditions[propertyCustom]
      }
      filterConditions = this.$engine.usercompany.getConditionObject()
      // this.$emit('applyFilter', actualFilter.getConditionObject())

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.activateSpinner = true
      this.$engine.usercompany.getUsers(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.users.length
        resp.data.users.forEach(item => {
          item.company_name = item.company_name
          item.login = item.login
          item.active = item.active
        })
        requests = resp.data.users
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.nameCompany = ''
      this.login = ''
      this.userActive = ''
      this.communicateChange()
      this.applyFilter()
    },
    deleteFilter () {
      this.$engine.usercompany.saveDefaultFilter({})
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: this.$i18n.t('administration.del_filter'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getCompanyName (infos) {
      return infos.Rights && infos.Rights[0] && infos.Rights[0].AccountName ? infos.Rights[0].AccountName : ''
    },
    saveDefaultFilter () {
      let that = this

      let defaultFilter = {
        nameCompany: this.nameCompany,
        login: this.login,
        userActive: this.userActive
      }

      this.$engine.usercompany.saveDefaultFilter(defaultFilter)

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        this[property] = defaultFilter[property]
        if (defaultFilter[property]) {
          this.hasDefaultFilter = true
        }
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportUserCompany () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Entreprise' + ';' +
        'Login' + ';' +
        'Active' + '\r\n'
      let lines = ''
      for (var i = 0; i < this.UsersList.length; i++) {
        let result = this.UsersList[i]
        let iconActive
        if (result.Active === "0") {
          iconActive = this.$t('administration.no')
        } else if (result.Active === "1") {
          iconActive = this.$t('administration.in_prgrss')
        } else if (result.Active === "2") {
          iconActive = this.$t('administration.yes')
        }
        lines += result.Rights[0].AccountName + ';' +
                 result.Login + ';' +
                 iconActive + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'usercompany_' + today.unix() + '.csv'
      if (
      this.$f7.device.os === 'android' ||
      this.$f7.device.os === 'ios'
      ) {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        let filterConditions
        if (this.$engine.usercompany.getDefaultFilter()) {
          filterConditions = this.$engine.usercompany.getDefaultFilter()
        } else {
          filterConditions = this.$engine.usercompany.getConditionObject()
        }
        filterConditions.sortField = 'SF' + this.sortField
        filterConditions.sortDirection = this.sortDirection
        this.$engine.usercompany.getUsers(
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          filterConditions
        ).then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.users.length
          resp.data.users.forEach(item => {
            item.login = item.login
            item.company_name = item.company_name
            item.active = item.active
          })
          requests = resp.data.users
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.UsersList.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions
      if (this.$engine.usercompany.getDefaultFilter()) {
        filterConditions = this.$engine.usercompany.getDefaultFilter()
      } else {
        filterConditions = this.$engine.usercompany.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection

      this.$engine.usercompany.getUsers(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users.length > 0) {
          that.paginationObject.nbResults = resp.data.users.length
          resp.data.users.forEach(item => {
          //  console.log(item)
          //  item.id_user_account = item.id_user_account
          //  item.login = item.login
          //  item.id_account = item.id_account
            item.delete = item.IdUser
          })
          requests = resp.data.users
          // console.log('requests  ',requests)
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (ressource, id) {
      let that = this
      loadPage(that, {url: '/detailusercompany/' + ressource + '/' + id})
    },
    activateEdit (ressource, id) {
      let that = this
      loadPage(that, {url: '/editusercompany/' + ressource + '/' + id})
    },
    activateDelete ($event, idUserToDelete) {
      $event.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.usercompany.deleteUser(idUserToDelete)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                that.onRefresh(false)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    reOrderBy (column) {
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      if (this.$engine.usercompany.getDefaultFilter()) {
        filterConditions = this.$engine.usercompany.getDefaultFilter()
      } else {
        filterConditions = this.$engine.usercompany.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.usercompany.getUsers(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.users.length
        resp.data.users.forEach(item => {
          item.login = item.login
          item.company_name = item.company_name
          item.active = item.active
        })
        requests = resp.data.users
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.UsersList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeUserDetails (items) {
      this.activateDetail(items[0].IdUser, items[0].id_account)
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>
